import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHero({ eyebrow, title, sub, image, crumbs = [] }) {
  return (
    <section className="relative overflow-hidden" style={{ background: "var(--teal-950)" }}>
      {image && (
        <img
          src={image}
          alt={title}
          className="absolute inset-0 h-full w-full object-cover"
          style={{ opacity: 0.5 }}
        />
      )}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(100deg, rgba(5,32,29,.94) 0%, rgba(5,32,29,.78) 50%, rgba(5,32,29,.5) 100%)",
        }}
      />
      <div className="grain absolute inset-0" />

      <div className="relative mx-auto max-w-[1280px] px-5 pb-20 pt-40 lg:px-6 lg:pb-24 lg:pt-48">
        <nav className="flex flex-wrap items-center gap-2 text-[0.76rem]" style={{ color: "rgba(251,247,240,.55)" }}>
          <Link to="/" className="hover:text-white" style={{ transition: "color .25s" }}>
            Home
          </Link>
          {crumbs.map((c) => (
            <span key={c.label} className="flex items-center gap-2">
              <ChevronRight size={12} />
              {c.to ? (
                <Link to={c.to} className="hover:text-white" style={{ transition: "color .25s" }}>
                  {c.label}
                </Link>
              ) : (
                <span style={{ color: "var(--gold-200)" }}>{c.label}</span>
              )}
            </span>
          ))}
        </nav>

        {eyebrow && (
          <div className="mt-8 flex items-center gap-3">
            <span className="h-[6px] w-[6px] rotate-45" style={{ background: "var(--gold-400)" }} />
            <span className="eyebrow" style={{ color: "var(--gold-200)" }}>
              {eyebrow}
            </span>
          </div>
        )}

        <h1
          className="font-display mt-5 max-w-[900px] text-[2.3rem] leading-[1.06] tracking-tight sm:text-[3.1rem] lg:text-[3.7rem]"
          style={{ color: "#FBF7F0", fontWeight: 300 }}
        >
          {title}
        </h1>

        {sub && (
          <p className="mt-6 max-w-[720px] text-[1.02rem] leading-relaxed" style={{ color: "rgba(251,247,240,.76)" }}>
            {sub}
          </p>
        )}
      </div>
    </section>
  );
}
